
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1sdq3_zrnh8_94",
  "input": "awsui_input_1sdq3_zrnh8_108",
  "results": "awsui_results_1sdq3_zrnh8_112",
  "results-visible": "awsui_results-visible_1sdq3_zrnh8_118"
};
  